/* eslint-disable array-callback-return */
import {
  BASE_URL,
  AUTH_GUEST_TOKEN,
  PRODUCTS_BY_CATEGORY,
  PRODUCTS_BY_BRAND,
  PRODUCTS_BY_SEARCH,
  DEFAULT_HEADER_VALUES,
  GOOGLE_GEOCODE_API_URL,
  MAP_API_KEY,
  CATEGORY_MENU_DATA_URL,
} from 'aster-foundation/core/common/utils/ApiConst';
import { getDataFromCookie, removeCookieByName } from 'aster-foundation/core/common/utils/cookieHelper';
import { generateTraceId } from 'aster-foundation/core/common/utils/utils';
import JwtDecode from 'jwt-decode';
import moment from 'moment';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import ListOfData from '../../../public/asterWebLandingPage.json';
import { dataLayerSendEvent } from './analytics-utils';
import {
  APP_LOCAL_DATETIME_FORMAT_SA,
  DELIVERY_TYPES,
  EXPRESS_DEFAULT_FLAG,
  GST_TIME_ZONE,
  HOME_CARE_ROUTE,
  INSTORE_DOMAIN,
  ONLINE_PHARMACY_ROUTE,
  PAYMENT_METHODS,
  PLP_PAGE_SIZE,
  RELATIVE_DATES,
  X_PATIENT_API_VERSION,
  X_USER_AGENT,
  getErrorType,
  COUNTRY_LIST,
  supportedlanguages,
  SESSION_STORAGE_KEYS,
  LOCALSTORAGE_KEYS
} from './constants';
import { convertDateMonthFormat, convertDateToCommaFormat, convertUtcToGst } from './date-utils';
import logger from './logger';
import { getQuery, getParams } from '../../pages/[region]-[lang]/online-pharmacy/c/[...categories]';
import { MY_ASTER_CATEGORY } from '@common/Constants/analytics';
import { IC_COD_DARK_GREY, IC_ORDERS_CREDIT_CARD, IC_PAY_APPLE, PRODUCT_CARD_DEFAULT } from '@common/Assets/images';
import { getLangCodeFromUrl, getRegionCodeFromUrl } from '../../../i18n';

const IMG_MB_SIZE = 10;
const HC_IMG_MB_SIZE = 10;
// export const NAME_FORMAT = /[\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
export const NUMBER_FORMAT = /[^0-9.]/g;
export const NUMBER_FORMAT_ONLY = /^[0-9]+$/;
// export const PASSPORT_FORMAT = /[a-zA-Z]{2}[0-9]{7}/;
export const MIN_MOBILE_WIDTH = 767;
export const NAME_STRING_FORMAT = /^[A-Za-z\s]+$/;
export const NAME_FORMAT = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
export const MESSAGE_FORMAT = /^\s+$/;
export const PASSPORT_FORMAT = /^[a-zA-Z0-9]*$/;
export const FLAT_FORMAT = /[^a-zA-Z0-9,/.\- ]/;
export const SEARCH_QUERY = /[\\(){}<>[\]]/g;
export const URL_QUERY = /[(),.]/g;
export const URL_TRIM = /[-,()\s]+/g;
export const MINIMUM_REQ_AGE = 12;
export const MINIMUM_RES_AGE = 13;
export const PD_MIN_REQ_AGE = 18;
export const MAX_QTY_ADD_TO_CART_PER_ORDER = 10;
export const GENDER_MALE = 'male';
export const UAE_CODE_DEFAULT = '+971';
export const IND_CODE_DEFAULT = '+91';
export const INVALID_ADDRESS_MESSAGE = `We couldn't find your address, Please move the pin to a valid location or Type address to search`;
export const OUT_OF_DELIVERY_MESSAGE = 'Our delivery service is not available in this area at the moment';
export const CONSULTATION_RESTRICTION_REASON_1 =
  'For patient below 13 years, please book a Pediatricians. If you would still like to book a GP, please contact our call center';
export const CONSULTATION_RESTRICTION_REASON_1_IP =
  'For patient below 13 years, please book a Pediatricians. If you would still like to book a internal medicine, please contact our call center';
export const CONSULTATION_RESTRICTION_REASON_2 =
  'Patients above the age of 18 are not allowed to book an appointment with Pediatricians.';
export const CONSULTATION_RESTRICTION_REASON_3 =
  'Males are not allowed to book an appointment with Obs/Gynecology doctors.';
export const CONSULTATION_RESTRICTION_REASON_4 =
  'Requested service is not covered by current insurance provider. Please add new insurance provider or select Self Pay option to book the appointment';
export const CONSULTATION_RESTRICTION_REASON_5 =
  'Requested service is not covered by current insurance provider. Please change the insurance provider or select Self Pay option to book the appointment';
export const GUEST_RESTRICTION_REASON1 =
  'Please register a family member above 12 years of age  to book an appointment with General doctors.';
export const GUEST_RESTRICTION_REASON2 =
  'Please register a female member to book an appointment with Gynaecology doctors.';
export const GUEST_RESTRICTION_REASON3 =
  'Please register a family member below 18 years of age  to book an appointment with General doctors.';
export const DEFAULT_CONSULTATION_MESSAGE = 'Please select the consultation type';
export const DEFAULT_PAYMENT_MESSAGE = 'Please select the payment option';
export const DEFAULT_SPECIALITY_MESSAGE = 'Please select the  speciality';
export const SPECIALITY_NAMES = {
  GENERAL_MEDICINE: 'General Medicine',
  PEDIATRICS: 'Pediatrics',
  OBS_AND_GYNEC: 'Obs & Gynae',
  DENTISTRY: 'Dentistry',
  DIETICIANS: 'Dietetics',
  INTERNAL_MEDICINE: 'Internal medicine',
};

export const SELECTED_PATH_INDEX = {
  MY_PROFILE: 'My Profile',
  EDIT_PROFILE: 'Edit Profile',
  MANAGE_PROFILE_MEMBER: 'Family Members',
  INSURANCE: 'Insurance',
  APPOINTMENTS: 'Appointments',
  MY_DOCTOR: 'My Doctors',
  ASTER_SECURE: 'Aster Secure',
  RECORDS: 'Records',
  MY_ORDERS: 'My Orders',
  MY_SHOPPING_LIST: 'My Shopping List',
  MANAGE_ADDRESS: 'Manage Address',
  MANAGE_PAYMENT: 'Manage Payment',
  RETURN_REFUND_POLICY: 'Cancellation, Return & Refund Policy',
  SETTING: 'Settings',
  NOTIFICATIONS: 'Notifications',
  BOOKMARKS: 'Lists',
  PATIENT_PORTAL: 'Patient Portal',
  MY_PACKAGE: 'My Packages',
  REFERRALS: 'Referrals'
};

export const ADD_FAMILY_MEMBER_TITLE = 'Add Family Member';
export const ADD_FAMILY_MEMBER_HC_TITLE = 'Add Your Family Member';
export const ADD_FAMILY_MEMBER_SUBTITLE = 'Book doctor appointments and manage health records for your family members.';
export const ADD_FAMILY_MEMBER_HOMECARE_SUBTITLE = `Book doctor and Homecare appointments and manage your family's health records.`;

export const PATIENT_RIGHT_PDF_URL =
  'https://asterdmstorageaccount.blob.core.windows.net/static/static_pages/Charter_of_Patients_Rights_and_Responsibilities_Policy_v1_2014.pdf';

export const convertPhoneNumberToServerFormat = (phoneNumber) => {
  const a = phoneNumber;
  let position = 0;
  if (phoneNumber?.startsWith(UAE_CODE_DEFAULT)) {
    position = 5;
  } else if (phoneNumber?.startsWith(IND_CODE_DEFAULT)) {
    position = 4;
  }

  return [a?.slice(position)].join('');
};

export const extValueForCountry = (phoneNumber) => {
  if (phoneNumber?.startsWith(IND_CODE_DEFAULT)) {
    return IND_CODE_DEFAULT;
  }
  return UAE_CODE_DEFAULT;
};

export const isEmpty = (value) => {
  const type = typeof value;
  if ((value !== null && type === 'object') || type === 'function') {
    const prop = Object.keys(value);
    if (prop.length === 0 || prop.size === 0) {
      return true;
    }
  }
  return !value;
};

export const validateMobileNumber = (mobileNumber, ext) => {
  const regexDubai1 = /^[0][5][0-9]{8}$/;
  const regexDubai2 = /^[5][0-9]{8}$/;
  const regexDubai = new RegExp(`${regexDubai1}||${regexDubai2}`);
  const regexIndia = /^[0-9]{10}$/;
  let mobNumberflag = false;
  if (ext === '+971') {
    mobNumberflag = regexDubai.test(mobileNumber) === false;
  } else if (ext === '+91') {
    mobNumberflag = regexIndia.test(mobileNumber) === false;
  }
  return mobNumberflag;
};

export const validateUAEMobileNumber = (inputNumber) => {
  const regexDubai = /^([5][0-9]{8}|[0][5][0-9]{8})$/gm;
  return regexDubai.test(inputNumber);
};

export const validateIndiaMobileNumber = (inputNumber) => {
  const regexIndia = /^[6789]\d{9}$/gm;
  return regexIndia.test(inputNumber);
};

export const getOnlyNumbersFromString = (string) => string.replace(NUMBER_FORMAT, '').replace(/(\..*)\./g, '');

export const getFieldsFromAnObjectArray = (input, field) => {
  const output = [];
  for (let i = 0; i < input.length; ++i) output.push(input[i][field]);
  return output;
};

export const getAge = (date) => {
  const dateString = date;
  if (dateString !== '') {
    const today = new Date();
    const bDate = new Date(dateString);
    let age = today.getFullYear() - bDate.getFullYear();
    const m = today.getMonth() - bDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < bDate.getDate())) {
      age--;
    }
    return age;
  }
};

export const getNationalityList = (list) => {
  const arr = [];
  if (list) {
    list.forEach((element) => {
      arr.push({
        text: element.code,
        value: element.id,
      });
    });
  }
  return arr;
};

export const getCountryList = (list) => {
  const arr = [];
  if (list) {
    list.forEach((element) => {
      arr.push({
        text: element.countryName,
        value: element.countryId,
        flagImage: element.imageURL,
      });
    });
  }
  return arr;
};

export const getCityList = (list) => {
  const arr = [];
  if (list) {
    list.forEach((element) => {
      arr.push({
        text: element.cityName,
        value: element.cityId,
        stateCode: element.stateCode,
      });
    });
  }
  return arr;
};

export const getBase64 = (file, cb) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    cb(reader.result);
  };
};

export const isImageSizeValid = (event) => {
  if (parseFloat(event?.target?.files?.[0]?.size / (1024 * 1024)).toFixed(2) <= IMG_MB_SIZE) return true;

  return false;
};

export const isHcImageSizeValid = (event) => {
  if (parseFloat(event?.target?.files?.[0]?.size / (1024 * 1024)).toFixed(2) <= HC_IMG_MB_SIZE) return true;

  return false;
};

export const getMinLengthErrorMsg = (name, type) => {
  if (name?.length === 0) {
    return `Please enter ${type}`;
  }
  if (name?.length < 4) {
    return 'Please enter minimum 3 characters';
  }
};

export const getEmiratesIDValidation = (emiratesID) => {
  const regexEmail = /^[_a-zA-Z0-9-]+(.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+[.]+([a-zA-Z0-9-]+)*(.[a-zA-Z]{2,4})$/;
  if (!regexEmail.test(emiratesID?.value)) {
    return 'Please enter a valid emirates-ID';
  }
  if (emiratesID?.length === 0) {
    return 'Please enter emirates-ID';
  }
};

export const validateEmail = (email) =>
  String(email)
    .toLowerCase()
    .match(
      /^(?=.{1,64}$)[a-zA-Z0-9]+([+._\-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.\-+][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/,
    );

export const alphaNumericRegex = (value) => {
  if (value) {
    return value.replace(/[^A-Za-z0-9]/g, '').replace(/(\..*)\./g, '');
  }
};

export const formatEmiratesId = (value) => {
  const rawInputOne = value.split('-').join(' ');
  const rawInputTwo = rawInputOne.split(' ').join('');
  const input = rawInputTwo;

  let first = null;
  let second = null;
  let third = null;
  let fourth = null;

  first = input.slice(0, 3);
  second = input.slice(3, 7);
  third = input.slice(7, 14);
  fourth = input.slice(14);

  let result = null;
  if (input.length > 14) {
    result = `${first}-${second}-${third}-${fourth}`;
  } else if (input.length > 7) {
    result = `${first}-${second}-${third}`;
  } else if (input.length > 3) {
    result = `${first}-${second}`;
  } else {
    result = `${first}`;
  }
  return result;
};

export const convertDateToBackendServer = (date) => (date ? moment(date).format('YYYY-MM-DD') : null);

export const convertDateToServer = (date) => (date ? moment(date).format('DD/MM/YYYY') : null);

export const convertDateToISOStandard = (date) => (date ? moment(date).format('YYYY/MM/DD') : null);

export const formatDate = (date) => {
  if (date) {
    const d = new Date(date);
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();
    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;
    return [year, month, day].join('-');
  }
  return null;
};

export const convertStringtoTitleCase = (str) =>
  str?.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

export const checkNotificationTypeByAppointment = (notification) => {
  if (
    notification?.eventType === 'AppointmentBook' ||
    notification?.eventType === 'SuccessfulPayment' ||
    notification?.eventType === 'AdminCancelAppointment' ||
    notification?.eventType === 'AppointmentChargeGenerate' ||
    notification?.eventType === 'UpcomingAppointment' ||
    notification?.eventType === 'PatientRescheduleAppointment' ||
    notification?.eventType === 'PatientModifyAppointment' ||
    notification?.eventType === 'PatientCancelAppointment'
  ) {
    return true;
  }
  return false;
};

const checkAuthMessage = (errArray) => {
  if (errArray?.[0]?.error_code?.indexOf('AUTH') > -1) {
    return errArray?.[0]?.display_message;
  }
  return null;
};

export const errorHandling = (err, hideToastIfNoMessage = false, screen_name = '', page_type = '') => {
  if (!err || isEmpty(err) || err?.errorCode === 401 || err?.data === 'Invalid Guest Token') return;
  const traceId = err?.traceId;
  const errPath = err?.reqURL?.split?.('?')?.[0];
  const errType = getErrorType(err?.errorCode);
  const errMessage = err?.data?.error || err?.errorMessage || 'Something went wrong';

  const handleToastAndDataEvent = (message) => {
    if (!hideToastIfNoMessage && message) {
      toast.error(message, { toastId: message });
    }
    dataLayerSendEvent('api_error', {
      error: message,
      err_path: err?.data?.path || errPath,
      err_status: err?.data?.status || err?.errorCode,
      err_type: errType,
      screen_name,
      page_type,
      trace_id: traceId,
    });
  };

  if (err?.data?.issue?.[0]?.diagnostics) {
    handleToastAndDataEvent(err?.data?.issue?.[0]?.diagnostics);
  }

  if (err?.data?.apiError?.message) {
    handleToastAndDataEvent(err?.data?.apiError?.message);
  }

  if (err?.data?.message) {
    handleToastAndDataEvent(err?.data?.message);
  }

  if (err?.data?.error_description && err?.errorCode !== 500) {
    handleToastAndDataEvent(err?.data?.error_description);
  }

  if (err?.data?.errors?.length > 0) {
    const authMessage = checkAuthMessage(err?.data?.errors) || errMessage;
    if (!hideToastIfNoMessage && authMessage) {
      toast.error(authMessage, { toastId: authMessage });
    }
    err?.data?.errors?.forEach((e) => {
      dataLayerSendEvent('api_error', {
        error: e?.message,
        err_path: err?.data?.path || errPath,
        err_status: e?.error_code || err?.data?.status || err?.errorCode,
        err_type: errType,
        screen_name,
        page_type,
        trace_id: traceId,
      });
    });
    return;
  }

  if (err?.data?.messages?.length > 0) {
    if (!hideToastIfNoMessage) {
      toast.error(errMessage, { toastId: errMessage });
    }
    err?.data?.messages?.forEach((message) => {
      dataLayerSendEvent('api_error', {
        error: message,
        err_path: err?.data?.path || errPath,
        err_status: err?.data?.status || err?.errorCode,
        err_type: errType,
        screen_name,
        page_type,
        trace_id: traceId,
      });
    });
    return;
  }
  // Default case
  handleToastAndDataEvent(errMessage);
  logger.error('Error: Stringifying the API Error Object', JSON.stringify(err));
};

export const errorHandlingEpharmacy = (err, hideToastIfNoMessage = false, screen_name = '', page_type = '') => {
  // removed duplicate error handling and merged both the methods
  errorHandling(err, hideToastIfNoMessage, screen_name, page_type);
};

export function checkRatingMatch(rating, childRatingValue, relation) {

  const ratingNum = parseFloat(rating);
  const childRatingNum = parseFloat(childRatingValue);

  let isMatch = false;
  switch (relation) {
      case "GT":
          isMatch = ratingNum > childRatingNum;
          break;
      case "GTE":
          isMatch = ratingNum >= childRatingNum;
          break;
      case "LT":
          isMatch = ratingNum < childRatingNum;
          break;
      case "LTE":
          isMatch = ratingNum <= childRatingNum;
          break;
      case "EQ":
          isMatch = ratingNum === childRatingNum;
          break;
      case "NEQ":
          isMatch = ratingNum !== childRatingNum;
          break;
      default:
          console.warn(`Unknown relation: ${relation}`);
          return false;
  }

  return isMatch;
};

export const getProperDateWithTime = (dateTime) => {
  const dateToCompare = moment.parseZone(dateTime).local();
  const today = moment(new Date());
  const tomorrow = moment(today).add(1, 'days');
  if (dateToCompare.startOf('day').isSame(today.startOf('day'))) {
    return (
      <>
        Available Today at <strong>{moment.parseZone(dateTime).local().format('h:mm A')}</strong>
      </>
    );
  }
  if (dateToCompare.startOf('day').isSame(tomorrow.startOf('day'))) {
    return (
      <>
        Available Tomorrow at <strong>{moment.parseZone(dateTime).local().format('h:mm A')}</strong>
      </>
    );
  }
  return (
    <>
      Available on{' '}
      <strong>
        {moment.parseZone(dateTime).local().format('DD MMM, YYYY')} {'at '}
        {moment.parseZone(dateTime).local().format('h:mm A')}
      </strong>
    </>
  );
};

export const getDayLabel = (formattedDate, format = APP_LOCAL_DATETIME_FORMAT_SA) => {
  const dateToCompare = moment(formattedDate, format).local();
  const today = moment().startOf('day');
  const tomorrow = moment().add(1, 'days').startOf('day');

  if (dateToCompare.isSame(today, 'day')) {
    return RELATIVE_DATES?.TODAY;
  } else if (dateToCompare.isSame(tomorrow, 'day')) {
    return RELATIVE_DATES?.TOMORROW;
  }
  return '';
};

export const getBookingType = (type) => {
  if (type === 'quickBooking') {
    return 'Quick Booking';
  }
  if (type === 'instantGP') {
    return 'Instant GP';
  }
  return 'Standard Booking';
};

const getProperDay = (dateTime, isInstantGP = false) => {
  if (
    moment(dateTime).calendar().split(' ')[0] === 'Today' ||
    moment(dateTime).calendar().split(' ')[0] === 'Tomorrow'
  ) {
    return `${moment(dateTime).calendar().split(' ')[0]}`;
  }
  if (
    moment(dateTime).calendar().split(' ')[0] === 'Monday' ||
    moment(dateTime).calendar().split(' ')[0] === 'Tuesday' ||
    moment(dateTime).calendar().split(' ')[0] === 'Wednesday' ||
    moment(dateTime).calendar().split(' ')[0] === 'Thursday' ||
    moment(dateTime).calendar().split(' ')[0] === 'Friday' ||
    moment(dateTime).calendar().split(' ')[0] === 'Saturday' ||
    moment(dateTime).calendar().split(' ')[0] === 'Sunday'
  ) {
    if (isInstantGP) {
      return `${moment(dateTime).calendar().split(' ')[0].substring(0, 3)}`;
    }
    return `${moment(dateTime).calendar().split(' ')[0]}`;
  }
  return `${moment(dateTime, 'YYYY-MM-DD HH:mm:ss').format('dddd')}`;
};

export const getProperDate = (dateTime, isInstantGP = false) =>
  `${getProperDay(dateTime, isInstantGP)}, ${moment
    .parseZone(dateTime)
    .local()
    .format(isInstantGP ? 'DD MMM' : 'DD MMMM')} at ${moment.parseZone(dateTime).local().format('h:mm A')}`;

export const getCardDate = (dateTime, isInstantGP = false) => {
  const modifiedDate = !dateTime?.endsWith('Z') ? `${String(dateTime)}Z` : dateTime;
  const withMomentDate = moment(modifiedDate).utcOffset(GST_TIME_ZONE);
  const convertedDateTime = `${getProperDay(withMomentDate, isInstantGP)}, ${withMomentDate
    .format(isInstantGP ? 'DD MMM' : 'DD MMMM')} at ${convertUtcToGst(modifiedDate)}`;
  return convertedDateTime;
};

export const getSlotTime = (time) => {
  const durationInSeconds = moment.parseZone(time).local().diff(moment.parseZone(new Date()).local(), 'seconds');
  const timeInMinutes = Math.ceil(durationInSeconds / 60);
  if (timeInMinutes <= 60) {
    return `${timeInMinutes} minutes`;
  }
  return getProperDate(time, true);
};

export const setSlotDetails = (details, mode) => {
  if (details?.slotStart && details?.slotStart !== null)
    sessionStorage.setItem('bookAppointmentLoginDate', convertDateToBackendServer(details?.slotStart));
  if (details?.slotId && details?.slotId !== null) sessionStorage.setItem('bookAppointmentLoginSlot', details?.slotId);
  if (details?.slotStart && details?.slotStart !== null) {
    const modifiedDate = !details?.slotStart?.endsWith('Z') ? `${details?.slotStart}Z` : details?.slotStart;
    sessionStorage.setItem('bookAppointmentLoginSlotStart', modifiedDate);
  }
  if (details?.slotEnd && details?.slotEnd !== null)
    sessionStorage.setItem('bookAppointmentLoginSlotEnd', details?.slotEnd);
  if (details?.hisSystem && details?.hisSystem !== null)
    sessionStorage.setItem('bookAppointmentLoginSlotHisId', details?.hisSystem);
  if (details?.refVal && details?.refVal !== null)
    sessionStorage.setItem('bookAppointmentLoginSlotHisRefVal', details?.refVal);
  if (details?.slotStart && details?.slotStart !== null) sessionStorage.setItem('bookAppointmentLoginType', mode);
};

export const clearSlotDetails = () => {
  sessionStorage.removeItem('bookAppointmentLoginType');
  sessionStorage.removeItem('bookAppointmentLoginSlot');
  sessionStorage.removeItem('bookAppointmentLoginSlotStart');
  sessionStorage.removeItem('bookAppointmentLoginSlotEnd');
  sessionStorage.removeItem('bookAppointmentLoginSlotHisId');
  sessionStorage.removeItem('bookAppointmentLoginSlotHisRefVal');
  sessionStorage.removeItem('bookAppointmentLoginSlotHisRefVal');
  sessionStorage.removeItem('bookAppointmentLoginDate');
};

export const getAddressDetailsFromGeoAPI = (mapSelectedLocation) => {
  const objAddressDetails = {
    cityName: '',
    locality: '',
    stateName: '',
    postalCode: '',
    subAreaName: '',
    countryName: '',
    neighborhood: '',
    areaName: '',
    premiseName: '',
    lat: '',
    long: '',
    formattedAddress: '',
  };
  mapSelectedLocation?.address_components?.forEach((element2) => {
    element2?.types?.forEach((element3) => {
      switch (element3) {
        case 'route':
          objAddressDetails.streetName = element2.long_name;
          break;
        case 'premise':
          objAddressDetails.premiseName = element2.long_name;
          break;
        case 'neighborhood':
          objAddressDetails.neighborhood = element2.long_name;
          objAddressDetails.areaName = element2.long_name;
          break;
        case 'sublocality':
          objAddressDetails.subAreaName = element2.long_name;
          if (objAddressDetails.areaName === '') {
            objAddressDetails.areaName = element2.long_name;
          }
          break;
        case 'administrative_area_level_2':
          if (objAddressDetails.areaName === '') {
            objAddressDetails.areaName = element2.long_name;
          }
          break;
        case 'administrative_area_level_1':
          objAddressDetails.stateName = element2.long_name;
          if (objAddressDetails.areaName === '') {
            objAddressDetails.areaName = element2.long_name;
          }
          break;
        case 'locality':
          objAddressDetails.cityName = element2.long_name;
          objAddressDetails.locality = element2.long_name;
          if (objAddressDetails.areaName === '') {
            objAddressDetails.areaName = element2.long_name;
          }
          break;
        case 'postal_code':
          objAddressDetails.postalCode = element2.long_name;
          break;
        case 'country':
          objAddressDetails.countryName = element2.long_name;
          break;
      }
    });
  });
  if (mapSelectedLocation && mapSelectedLocation.geometry && mapSelectedLocation.geometry.location) {
    objAddressDetails.lat = `${mapSelectedLocation.geometry.location.lat}`;
    objAddressDetails.long = `${mapSelectedLocation.geometry.location.lng}`;
  }
  if (mapSelectedLocation && mapSelectedLocation.formatted_address) {
    objAddressDetails.formattedAddress = mapSelectedLocation.formatted_address;
  }
  return objAddressDetails;
};

export const formatPhoneNumber = (phoneNumberString) => {
  const prefix = phoneNumberString.split('-')[0];
  const cleaned = `${phoneNumberString.split('-')[1]}`.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{2})(\d{3})(\d{4})$/);

  if (match) {
    return `${prefix} ${match[1]}-${match[2]}-${match[3]}`;
  }
  return phoneNumberString;
};

export const getPreSelectedPatientId = (patientId) => {
  if (typeof window !== 'undefined' && localStorage.getItem('PreselectedPatientId')) {
    return localStorage.getItem('PreselectedPatientId');
  }
  return patientId;
};

export const checkTokenValidity = (accessToken) => {
  const decodedAccessTokenData = JwtDecode(accessToken);
  const tokenExpiryTimeStamp = decodedAccessTokenData.exp;
  const currentTimeStamp = Math.floor(new Date() / 1000);
  return tokenExpiryTimeStamp > currentTimeStamp;
};

export const getConfigurationValue = (appConfiguration, configValue) =>
  appConfiguration?.find((config) => config?.name === configValue)?.value;

export const getConfigurationValueByFilter = (appConfiguration, configValue) =>
  appConfiguration?.filter((config) => config?.name === configValue);

export const getConfigurationValueByDescription = (appConfiguration, configValue) =>
  appConfiguration?.find((config) => config?.description === configValue)?.value;

export const getConfigurationActiveValueByName = (appConfiguration, configValue) =>
  appConfiguration?.find((config) => config?.name === configValue)?.active;

export const getProfileStatusLabel = (status) => {
  if (status === 'under review') {
    return 'Under Review';
  }
  if (status === 'rejected') {
    return 'Rejected';
  }
  if (status === 'verified') {
    return 'Verified';
  }
  if (status === 'pending verification') {
    return 'Verification Pending';
  }
  return 'Incomplete Profile';
};

export const getProfileStatusClass = (status) => {
  if (status === 'verified' || status === 'valid') {
    return 'verified';
  }
  if (status === 'pending verification' || status === 'under review') {
    return 'pending';
  }
  if (status === 'rejected') {
    return 'rejected';
  }
  return 'incomplete';
};

export const getNotificationsTime = (timeData) => {
  let time = '';
  if (timeData && timeData.length > 0) {
    const date = moment(new Date(timeData));
    if (date.isValid()) {
      time = `${moment(date).format('DD MMM, YYYY')}, ${moment(date).format('h:mm A')}`;
    } else {
      time = `${timeData} ago`;
    }
  }
  return time;
};

export const fLCapital = (s) => s?.charAt(0)?.toUpperCase() + s?.slice(1);

export const getOrderStatusClass = (status) => {
  const lowered = status?.toLowerCase();
  if (
    lowered === 'delivered' ||
    lowered === 'out for delivery' ||
    lowered === 'shipped' ||
    lowered === 'order delivered' ||
    lowered === 'success'
  ) {
    return 'verified';
  }
  if (
    lowered === 'received'
  ) {
    return 'Received';
  }
  if (
    lowered === 'cancelled' ||
    lowered === 'return rejected' ||
    lowered === 'returned' ||
    lowered === 'delivery failed'
  ) {
    return 'cancel';
  }
  if (lowered === 'picked up') {
    return 'picked-up-wo-image';
  }
  if (lowered === 'order confirmed') {
    return 'order-confirmed-wo-image';
  }
  if (lowered === 'pick up scheduled') {
    return 'picked-up-scheduled-wo-image';
  }
  if (lowered === 'return received') {
    return 'picked-up';
  }
  return 'process';
};

export const makeTraceId = () => generateTraceId();

export const getApiAuthHeader = (otherHeaders = {}) => {
  const deviceId = otherHeaders?.deviceId ? otherHeaders?.deviceId : uuidv4();
  const traceId = typeof window !== 'undefined' ? getDataFromCookie('traceId') : makeTraceId();
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-patient-apiversion': X_PATIENT_API_VERSION,
    'X-User-Agent': X_USER_AGENT,
    'Client-Id':'web',
    platform: 'web',
    deviceId,
    traceId,
    'new-auth-service': true,
    ...otherHeaders,
  };
};

export const breadCrumbDecoder = (data) => convertStringtoTitleCase(data?.split('-')?.join(' '));

export const doctorNameEncoder = (data) => data?.split(' ')?.join('-').toLowerCase();

export const removeDecimalPoints = (x) => {
  if (parseInt(x?.split('.')?.pop()) === 0) return parseInt(x);
  return x?.split('')?.includes('.') ? Number?.parseFloat(x)?.toFixed(2) : x;
};

export const getServicePath = (servie) => {
  let pathName = `${ONLINE_PHARMACY_ROUTE}/p`;
  // if (servie?.customAttribute?.categoryIds) {
  //   pathName += '/' + servie?.customAttribute?.categoryIds?.split(',')?.[0];
  // }
  if (servie?.customAttribute?.urlKey?.length > 0) {
    pathName += `/${encodeURIComponent(servie?.name)}/${servie?.customAttribute?.urlKey}`;
  }
  pathName += `/${encodeURIComponent(servie?.name)}/${servie?.sku}`;
  return pathName;
};

export const getProductPath = (product) => {
  const pathName = `${ONLINE_PHARMACY_ROUTE}/${product?.productUrl}`;
  return pathName;
};

export const getWishlistProductPath = (product) => {
  const pathName = `${ONLINE_PHARMACY_ROUTE}/${product?.product_url}`;
  return pathName;
};

export const getNewCartProductPath = (product) => {
  const pathName = `${ONLINE_PHARMACY_ROUTE}${product?.product_url}`;
  return pathName;
};

export const getVariantProductPath = (product) => {
  const pathName = `${ONLINE_PHARMACY_ROUTE}/p/${product?.parent_sku}`;
  return pathName;
};

export const getAddressDataFromLatLng = (latitude, longitude, callback) => {
  fetch(
    `${GOOGLE_GEOCODE_API_URL}geocode/json?latlng=${latitude},${longitude}&key=${MAP_API_KEY}`,
  )
    .then((response) => response.json())
    .then(async (response) => {
      const res = response.results;
      const locationData = getAddressDetailsFromGeoAPI(res?.[0]);
      callback && callback(res, locationData);
    });
};

export const setChildElements = (elementKeys, el) => {
  if (elementKeys?.length > 0) {
    const child = setChildElements(
      elementKeys?.filter((i) => i !== elementKeys[0]),
      el,
    );
    const childElem = {
      ...el,
      key: elementKeys[0],
      child: child ? [child] : [],
    };
    return childElem ?? [];
  }
  if (elementKeys[0]) {
    return {
      ...el,
      key: elementKeys[0],
      child: [],
    };
  }
};

export const searchTree = (element, matchingTitle) => {
  if (String(element?.displayName)?.toLowerCase()?.indexOf(String(matchingTitle)?.toLowerCase()) !== -1) {
    const keySplitted = element?.key?.split('/');
    let currentKey = '';
    const returnArray = [];
    for (let i = 0; i < keySplitted.length; i++) {
      if (currentKey !== '') {
        currentKey += '/';
      }
      currentKey += keySplitted[i];
      if (i === 0) {
        continue;
      }
      returnArray.push({ key: `${currentKey}`, displayName: keySplitted[i], ...element });
    }
    return returnArray;
  }
  return null;
};

export const mergeArray = (arr) => {
  const output = [];
  arr.forEach((item) => {
    const existing = output.filter((v, i) => v.key === item.key);
    if (existing.length) {
      const existingIndex = output.indexOf(existing[0]);
      if (output?.[existingIndex]?.child && item?.child) {
        const childArrayCombined = mergeArray([...output[existingIndex].child, ...item.child]);
        output[existingIndex] = {
          ...output[existingIndex],
          child: childArrayCombined,
        };
      } else if (item?.child) {
        output[existingIndex] = {
          ...output[existingIndex],
          child: [...item.child],
        };
      }
    } else {
      output.push(item);
    }
  });
  return output;
};

export const getCategoryChildArray = (data, parentEl, level) => {
  let childData = data.filter((el) => {
    const elKey = el.key.split('/');
    if (elKey[level] && elKey?.length === level + 1) {
      return el?.key?.startsWith(parentEl?.key) && el?.key !== parentEl?.key;
    }
    return false;
  });

  if (childData?.length > 0) {
    childData = childData?.map((childEl) => ({ ...childEl, child: getCategoryChildArray(data, childEl, level + 1) }));
  }
  return childData;
};
export const getLevelCategoryArray = (data, level = 0) => {
  let retData = [];
  data.forEach((el) => {
    const elKey = el.key.split('/');
    if (elKey[level] && elKey?.length === level + 1) {
      retData.push(el);
    }
  });
  retData = retData.filter((value, index, self) => self.indexOf(value) === index);
  if (retData?.length > 0) {
    retData = retData?.map((el) => ({ ...el, child: getCategoryChildArray(data, el, level + 1) }));
  }
  return retData;
};

export const transformDataToTree = (data) => {
  let newData = [];
  data.forEach((el) => {
    const elKey = el.key.split('/');
    let levelData = {};
    if (elKey?.length > 0) {
      const childData = setChildElements(elKey, { ...el, path: el?.key });
      levelData = childData;
    } else {
      levelData.push({
        ...el,
        path: el?.key,
        key: elKey[0],
        child: [],
      });
    }
    newData?.push(levelData);
  });
  if (newData?.length > 0) {
    newData = mergeArray(newData);
  }
  return newData;
};

export const getQueryStringFromObject = (obj) => {
  if (Object.keys(obj).length > 0) {
    let queryString = '';
    Object?.keys(obj)?.forEach((element) => {
      if (queryString !== '') queryString += ':';
      queryString += `${element}:${obj[element]}`;
    });
    return queryString;
  }
  return '';
};
export const consoleDateTime = (name) =>
  console.log(name, new Date().toLocaleString(undefined, { timeZone: 'Asia/Kolkata' }));

export function getQueryString(requestParams) {
  if (requestParams) {
    let queryString = Object.keys(requestParams).length === 0 ? '' : '?';
    for (const key in requestParams) {
      if (requestParams[key] !== '') {
        if (queryString === '?') {
          queryString = `${queryString + key}=${requestParams[key]}`;
        } else {
          queryString = `${queryString}&${key}=${requestParams[key]}`;
        }
      }
    }
    return queryString;
  }
  return '';
}

export function getAttributeItemFromArray(attributes, key) {
  let value = '';
  if (attributes) {
    value = attributes?.find((item) => item?.attributeCode === key);
  }
  return value ? value?.value : '';
}

export function getAsterCategory(url) {
  if (url?.includes('online-pharmacy')) {
    return MY_ASTER_CATEGORY?.AE;
  }
  if (url?.includes('doctor-consultation')) {
    return MY_ASTER_CATEGORY?.DOCTOR_CONSULT;
  }
  if (url?.includes('home-care')) {
    return MY_ASTER_CATEGORY?.HC;
  }
  return MY_ASTER_CATEGORY?.ASCO;
}

export function getMyAsterCategory(url) {
  if (url?.includes('online-pharmacy')) {
    return MY_ASTER_CATEGORY?.AE;
  }
  if (url?.includes('doctor-consultation')) {
    return MY_ASTER_CATEGORY?.DOCTOR_CONSULT;
  }
  return MY_ASTER_CATEGORY?.ASCO;
}

export function getReferralPageForGA(path) {
  let referrerUrl = path;
  if (path?.indexOf('/') >= 0) {
    referrerUrl = path.split('/');
  }

  let lastPage = '';
  if (referrerUrl?.includes('online-pharmacy') && referrerUrl?.includes('p')) {
    lastPage = 'Products Details Page';
  } else if (referrerUrl?.includes('online-pharmacy') && referrerUrl?.includes('c')) {
    lastPage = 'Products Listing Page';
  } else if (referrerUrl?.includes('online-pharmacy') && referrerUrl?.includes('deals')) {
    lastPage = 'Deals page';
  } else if (referrerUrl?.includes('online-pharmacy') && referrerUrl?.includes('brandlisting')) {
    lastPage = 'Brands Listing Page';
  } else if (referrerUrl?.includes('online-pharmacy') && referrerUrl?.includes('categorylisting')) {
    lastPage = 'Category Listing Page';
  } else if (referrerUrl?.includes('online-pharmacy') && referrerUrl?.includes('brand')) {
    lastPage = 'Brand Listing Page';
  } else if (referrerUrl?.includes('online-pharmacy') && referrerUrl?.includes('rxupload')) {
    lastPage = 'Rx Upload Page';
  } else if (referrerUrl?.includes('online-pharmacy') && referrerUrl?.includes('mycart')) {
    lastPage = 'My Cart Page';
  } else if (referrerUrl?.includes('online-pharmacy') && referrerUrl?.includes('myorders')) {
    lastPage = 'My Orders Page';
  } else if (referrerUrl?.includes('myshoppinglist')) {
    lastPage = 'My Shopping List Page';
  } else if (referrerUrl?.includes('online-pharmacy') && referrerUrl?.includes('referrals')) {
    lastPage = 'main referrals';
  } else if (referrerUrl?.includes('online-pharmacy') && referrerUrl?.some((x) => x.indexOf('paymentsuccess') > -1)) {
    lastPage = 'Order Confirmation Page';
  } else if (referrerUrl?.includes('online-pharmacy') && referrerUrl?.some((x) => x.indexOf('searchresult') > -1)) {
    lastPage = 'Search Result Page';
  } else if (referrerUrl?.includes('online-pharmacy')) {
    lastPage = 'Epharmacy Homepage';
  } else if (
    referrerUrl?.includes('doctor-consultation') &&
    referrerUrl?.includes('instantgp') &&
    referrerUrl?.includes('details')
  ) {
    lastPage = 'InstantGP Information Page';
  } else if (
    referrerUrl?.includes('doctor-consultation') &&
    referrerUrl?.includes('instantgp') &&
    referrerUrl?.includes('checkout')
  ) {
    lastPage = 'InstantGP Checkout Page';
  } else if (referrerUrl?.includes('doctor-consultation') && referrerUrl?.includes('s')) {
    lastPage = 'Doctor Listing Page';
  } else if (referrerUrl?.includes('doctor-consultation') && referrerUrl?.includes('d')) {
    lastPage = 'Doctor Details Page';
  } else if (referrerUrl?.includes('doctor-consultation') && referrerUrl?.includes('f')) {
    lastPage = 'Clinic Detail Page';
  } else if (referrerUrl?.includes('doctor-consultation') && referrerUrl?.includes('quickbooking')) {
    lastPage = 'QuickBooking Page';
  } else if (referrerUrl?.includes('doctor-consultation') && referrerUrl?.includes('doctors')) {
    lastPage = 'NewDoctors Listing Page';
  } else if (referrerUrl?.includes('doctor-consultation') && referrerUrl?.includes('speciality-list')) {
    lastPage = 'Speciality Listing Page';
  } else if (referrerUrl?.includes('doctor-consultation') && referrerUrl?.includes('clinic-list')) {
    lastPage = 'Clinic Listing Page';
  } else if (
    referrerUrl?.includes('doctor-consultation') &&
    referrerUrl?.includes('checkout') &&
    referrerUrl?.includes('detail')
  ) {
    lastPage = 'Booking Status Page';
  } else if (referrerUrl?.includes('doctor-consultation') && referrerUrl?.includes('checkout')) {
    lastPage = 'Appointment Checkout Page';
  } else if (
    referrerUrl?.includes('doctor-consultation') &&
    referrerUrl?.includes('appointments') &&
    referrerUrl?.includes('list')
  ) {
    lastPage = 'Appointment Listing Page';
  } else if (
    referrerUrl?.includes('doctor-consultation') &&
    referrerUrl?.includes('appointments') &&
    referrerUrl?.includes('detail')
  ) {
    lastPage = 'Appointment Detail Page';
  } else if (
    referrerUrl?.includes('doctor-consultation') &&
    referrerUrl?.includes('appointments') &&
    referrerUrl?.includes('postconsultation')
  ) {
    lastPage = 'PostConsultation Summary Page';
  } else if (referrerUrl?.includes('doctor-consultation')) {
    lastPage = 'Tele-consult Homepage';
  } else if (referrerUrl?.includes('home-care') && referrerUrl?.includes('services')) {
    lastPage = 'Homecare Services Listing page';
  } else if (referrerUrl?.includes('home-care') && referrerUrl?.includes('searchresult')) {
    lastPage = 'Homecare Search page';
  } else if (referrerUrl?.includes('home-care') && referrerUrl?.includes('rxupload')) {
    lastPage = 'Homecare Rxupload page';
  } else if (referrerUrl?.includes('home-care') && referrerUrl?.includes('my-cart')) {
    lastPage = 'Homecare my-cart page';
  } else if (
    referrerUrl?.includes('home-care') &&
    referrerUrl?.includes('my-cart') &&
    referrerUrl?.includes('appointment')
  ) {
    lastPage = 'Homecare Appointment page';
  } else if (referrerUrl?.includes('home-care') && referrerUrl?.includes('confirmation')) {
    lastPage = 'Homecare Confirmation page';
  } else if (referrerUrl?.includes('home-care') && referrerUrl?.includes('checkout')) {
    lastPage = 'Homecare Checkout page';
  } else if (referrerUrl?.includes('home-care') && referrerUrl?.includes('appointments')) {
    lastPage = 'Homecare Appointments page';
  } else if (referrerUrl?.includes('home-care') && referrerUrl?.includes('feedback')) {
    lastPage = 'Homecare Feedback Page';
  } else if (referrerUrl?.includes('home-care') && referrerUrl?.includes('mypackage')) {
    lastPage = 'Homecare mypackage Page';
  } else if (referrerUrl?.includes('home-care')) {
    lastPage = 'Homecare Homepage';
  } else if (referrerUrl?.includes('profile') && referrerUrl?.includes('myprofile')) {
    lastPage = 'Profile Homepage';
  } else lastPage = 'Asco Homepage';
  return lastPage;
}

export const getReplaceHtmlTags = (htmlStr = '') => (htmlStr || '').replace(/<(.|\n)*?>/g, '');

export const convertToSHA256Hashed = async (data) => {
  const textEncoder = new TextEncoder();
  const textAsBuffer = textEncoder?.encode(data);
  const hashBuffer = await window.crypto?.subtle?.digest('SHA-256', textAsBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const digest = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  return digest;
};

export const isTopBarDealsVisible = (routeUrl) => {
  const excludedRoutes = [
    'checkout',
    'myorders',
    'rxupload',
    'cancellationconfirmation',
    'returnpolicy',
    'cancelpolicy',
  ];
  return (
    routeUrl &&
    routeUrl.includes(ONLINE_PHARMACY_ROUTE) &&
    !excludedRoutes.some((excludedRoute) => routeUrl.includes(excludedRoute))
  );
};

export const getSearchCategoryIds = (suggestions) => {
  const resultIds = suggestions?.slice(0, 5)?.reduce((acc, curr) => {
    const { categoryId } = curr;
    if (categoryId) {
      acc.push(categoryId);
    }
    return acc;
  }, []);
  return resultIds.length > 0 ? resultIds : null;
};

export const getImageSrc = (imageSrc) => imageSrc || '/';

export const getImageUrlWithSize = (imageUrl, width, height) => {

  if(!imageUrl){
    return imageUrl;
  }

  const baseUrl = imageUrl || '/';

  const widthParam = width ? `width=${2*width}` : '';
  const heightParam = height ? `height=${2*height}` : '';

  const separator = width && height ? '&' : '';

  return `${baseUrl}${widthParam || heightParam ? '?' : ''}${widthParam}${separator}${heightParam}`;
};

export const isItemAllNull = (item) => {
  if (!item.data) {
    return true;
  }
  return item?.item === 'BODY_MEASUREMENT'
    ? !item?.data?.bmi
    : Object.values(item.data).every((value) => value === null);
};

export const isItemNoNull = (item) => {
  if (!item.data) {
    return false;
  }
  return item?.item === 'BODY_MEASUREMENT' ? item?.data?.bmi : Object.values(item.data).some((value) => value !== null);
};

export const checkConditions = (data, key) => {
  const isAllNull = data?.every((item) => isItemAllNull(item));
  const isNoNull = data?.every((item) => isItemNoNull(item));
  const isSomeNull = !isAllNull && !isNoNull;

  if (isAllNull) {
    return key ? HP_BANNER_TYPE.CREATE : 'allNull';
  } else if (isSomeNull) {
    return key ? HP_BANNER_TYPE.PARTIAL : 'someNull';
  } else {
    return key ? HP_BANNER_TYPE.BMI : '';
  }
};

export const removeDuplicates = (responseArray, filterElement) => {
  // Declare an empty object
  const uniqueObject = {};
  const uniqueArray = [];

  // Loop for the array elements

  if (responseArray && responseArray.length > 0) {
    responseArray.map((_element, index) => {
      const objTitle = responseArray[index][filterElement];
      // Use the position as the index
      uniqueObject[objTitle] = responseArray[index];
      return uniqueObject;
    });
  }

  Object.keys(uniqueObject).map((index) => {
    uniqueArray.push(uniqueObject[index]);
    return uniqueArray;
  });
  return uniqueArray;
};

export const sortArrayResponseAsc = (resArray, element) => {
  if (resArray) {
    return resArray.sort((a, b) => a[element] - b[element]);
  }
};

export const getJSONParseValue = (value) => {
  try {
    if (value) {
      return JSON.parse(value);
    }
  } catch (error) {
    logger.warn('JSON Error', error);
  }
};

export const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export const getFormattedDate = (date) => {
  if (date !== null && date !== 'null') {
    return `${moment(date).calendar().split(' ')[0] === 'Today' ||
        moment(date).calendar().split(' ')[0] === 'Tomorrow' ||
        moment(date).calendar().split(' ')[0] === 'Monday' ||
        moment(date).calendar().split(' ')[0] === 'Tuesday' ||
        moment(date).calendar().split(' ')[0] === 'Wednesday' ||
        moment(date).calendar().split(' ')[0] === 'Thursday' ||
        moment(date).calendar().split(' ')[0] === 'Friday' ||
        moment(date).calendar().split(' ')[0] === 'Saturday' ||
        moment(date).calendar().split(' ')[0] === 'Sunday'
        ? `${moment(date).calendar().split(' ')[0]}, `
        : `${moment(date, 'YYYY-MM-DD HH:mm:ss').format('dddd')}, `
      }${convertDateMonthFormat(date) !== null ? convertDateMonthFormat(date) : ''}`;
  }
};

export const getFormattedDateValue = (date) => {
  if (date !== null && date !== 'null') {
    return `${moment(date).calendar().split(' ')[0] === 'Today' ? `${moment(date).calendar().split(' ')[0]}, ` : ''}${convertDateMonthFormat(date) !== null ? convertDateMonthFormat(date) : ''
      }`;
  }
};

export const getProductPathForHomeCare = (name, params) => {
  let pathName;
  if (params) {
    const serviceName = params && params?.replace(/\s+/g, '-').toLowerCase();
    pathName = `${HOME_CARE_ROUTE}/services/${serviceName}`;
    pathName += `/${encodeURIComponent(
      name
        ?.replace(/[^\w\s]/gi, '')
        .replace(/\s+/g, '-')
        .toLowerCase(),
    )}`;
  } else {
    pathName = `${HOME_CARE_ROUTE}/searchresult`;
    pathName +=
      '/' +
      `${encodeURIComponent(
        name
          ?.replace(/[^\w\s]/gi, '')
          .replace(/\s+/g, '-')
          .toLowerCase(),
      )}`;
  }
  return pathName;
};

export const capitalizeFirstLetterInEachWord = (input) => {
  const removedTheSpecialChar = input?.split('')?.join('')?.replaceAll('-', ' ');
  return removedTheSpecialChar
    ?.toLowerCase()
    ?.split(' ')
    ?.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
};

export function timeConvert(n) {
  const hours = Math.trunc(n / 60);
  const minutes = n % 60;
  let hoursText = '';
  let minutesText = '';
  if (n === 0) {
    return `${minutes} Minutes`;
  }
  if (hours === 1) {
    hoursText = `${hours} Hour `;
  } else if (hours > 0) {
    hoursText = `${hours} Hours `;
  }
  if (minutes === 1) {
    minutesText = `${minutes} Minute`;
  } else if (minutes > 0) {
    minutesText = `${minutes} Minutes`;
  }
  return hoursText + minutesText;
}

export const serializePatientObject = (element) => {
  const id = element?.resource?.id;
  const name = element?.resource?.name.find((itm) => itm.text)?.text;
  const phone = element?.resource?.telecom.find((itm) => itm.system === 'phone')?.value;
  const email = element?.resource?.telecom.find((itm) => itm.system === 'email')?.value;
  const profilePic = element?.resource?.photo[0]?.url;
  let isPrimary = false;
  let relationship = 'Self';
  let status = null;
  const allProfiles = false;
  let nameInitials = '';
  let isProfileIncomplete = false;

  element?.resource?.extension?.forEach((extensionItem) => {
    if (extensionItem.url === 'relationShip') {
      relationship = extensionItem.valueString;
    }

    if (extensionItem.url === 'status') {
      status = extensionItem.valueString;
      isProfileIncomplete = extensionItem.valueString === 'incomplete profile';
    }

    if (extensionItem.url === 'isPrimary') {
      isPrimary = extensionItem.valueBoolean;
    }

    if (extensionItem.url === 'nameInitials') {
      nameInitials = extensionItem.valueString;
    }
  });

  return {
    id,
    name,
    profilePic,
    isPrimary,
    relationship,
    status,
    allProfiles,
    nameInitials,
    isProfileIncomplete,
    phone,
    email,
  };
};

export const getCartItemFromServiceObject = (serviceObject, _cartId = 0, priceValue) => {
  const cartId = _cartId;
  const productId = serviceObject?.hisid;
  const productName = serviceObject?.name;
  const productDesc = serviceObject?.shortDescription;
  const quantity = 1;
  // const price = serviceObject?.price?.salesPrice;
  const price = priceValue;
  const startTime = '2023-03-17T20:10:33.657Z';
  const endTime = '2023-03-17T20:10:33.657Z';
  const cartType = 'HOMECARE';

  return {
    cartId,
    productId,
    productName,
    productDesc,
    quantity,
    price,
    startTime,
    endTime,
    cartType,
  };
};

export const DATATYPE = { SERVICES: 'Services', PACKAGES: 'Packages' };

export const HOME_CARE_DATATYPE = {
  SERVICES: 'services',
  PACKAGES: 'packages',
};

export function isRxNeeded(item) {
  let isRxNeededVar = false;
  if (item?.services?.length > 0) {
    isRxNeededVar = item?.services?.find((x) => x?.isRxNeeded)?.isRxNeeded;
  } else {
    isRxNeededVar = item?.isRxNeeded;
  }
  return isRxNeededVar ?? false;
}
export function isConsentNeeded(item) {
  let isConsentNeededVariable = false;
  if (item?.services?.length > 0) {
    isConsentNeededVariable = item?.services?.find((x) => x?.isConsentNeeded)?.isConsentNeeded;
  } else {
    isConsentNeededVariable = item?.isConsentNeeded;
  }
  return isConsentNeededVariable ?? false;
}

export const splitTheWord = (text) => text.split('\n').map((i) => <p key={i}>{i}</p>);

export const getCurrentYear = () => {
  const d = new Date();
  return d.getFullYear();
};

export const isIntegerNumber = (num) => {
  if (num && (num ^ 0) === num) {
    return num;
  }
  return num?.toFixed(2);
};

export const isServiceAbleToCurrentLocation = (data) => {
  // Check if any object has serviceable set to true
  const hasServiceableTrue = data?.some((obj) => obj?.serviceable);

  // Check if all objects have serviceable set to true
  const allServiceableTrue = data?.every((obj) => obj?.serviceable);

  const result = hasServiceableTrue || allServiceableTrue;

  return result;
};

export const removeSpacesWithHyphen = (str) =>
  str
    ?.replace(/[^\w\s]/gi, '')
    .replace(/\s+/g, '-')
    .toLowerCase();
export const getProfileList = (data, specialisation, isFromBookappointment = false) => {
  if (data && data.length > 1) {
    return true;
  }
  if (data.length === 1) {
    const temp = data?.[0];
    if (temp.age > MINIMUM_RES_AGE && specialisation === SPECIALITY_NAMES?.GENERAL_MEDICINE && !isFromBookappointment) {
      return true;
    }
    if (temp.age <= PD_MIN_REQ_AGE && specialisation === SPECIALITY_NAMES?.PEDIATRICS) {
      return true;
    }
    if (temp?.gender !== GENDER_MALE && specialisation === SPECIALITY_NAMES?.OBS_AND_GYNEC) {
      return true;
    }
    return false;
  }
  return false;
};
export const getPriceValueInServiceData = (serviceAndPackageData, priceArray) => {
  let mergingTheServices;
  if (serviceAndPackageData?.length > 0 && priceArray) {
    mergingTheServices = serviceAndPackageData.map((item) => ({
      ...item,
      price: priceArray.filter((subItem) => {
        if (String(subItem.ServiceId) === item.hisid) {
          return subItem;
        } else {
          return null;
        }
      }),
    }));
    return mergingTheServices;
  }
};

export const getViewAllLink = (item) => {
  if (item?.type === 'category') {
    if (item?.metaData) {
      return `${ONLINE_PHARMACY_ROUTE}/c/${encodeURIComponent(item?.metaData?.name)}/${item?.metaData?.id}`;
    }
    return `${ONLINE_PHARMACY_ROUTE}/c/${item?.id}`;
  }
  if (item?.type === 'brand') {
    if (item?.metaData) {
      return `${ONLINE_PHARMACY_ROUTE}/brand/${encodeURIComponent(item?.metaData?.name)}/${item?.metaData?.id}`;
    }
    return `${ONLINE_PHARMACY_ROUTE}/brand/${item?.id}`;
  }
  if (item?.type === 'offerType') {
    return `${ONLINE_PHARMACY_ROUTE}/searchresult?offerType=${item?.id}&title=${encodeURIComponent(item?.title)}`;
  }
  return ONLINE_PHARMACY_ROUTE;
};

export const getHomePageJson = async (filename) => {
  const fileURL = `${CATEGORY_MENU_DATA_URL}/static/static_pages/${filename}`;
  try {
    const response = await fetch(fileURL);
    return await response.json();
  } catch (error) {
    return ListOfData;
  }
};

export async function getGuestToken(deviceId) {
  try {
    const response = await fetch(`${BASE_URL}${AUTH_GUEST_TOKEN}`, {
      method: 'POST',
      headers: getApiAuthHeader({ deviceId }),
      body: null,
    });
    const data = await response.json();
    return data?.body?.guestToken || '';
  } catch (error) {
    return '';
  }
}

export async function fetResultAPI(apiUrlEndPoint, deviceId, accessToken) {
  try {
    const response = await fetch(BASE_URL + apiUrlEndPoint, {
      headers: getApiAuthHeader({
        Authorization: `guest-token ${accessToken}`,
        deviceId,
      }),
    });
    return await response.json();
  } catch (error) {
    return false;
  }
}

const isBannerComponent = (item) => ['banner_carousel', 'static_banner'].includes(item?.component);

const isOffBoxComponent = (item) => ['offBox'].includes(item?.component);

const isCategoryComponent = (item) =>
  ['popular_category', 'personal_care_essentials', 'shop_by_brand', 'featured_category'].includes(item?.component);

const updateBannerComponent = async (item, deviceId, accessToken) => {
  const bannerResult = await fetResultAPI(item.api, deviceId, accessToken);
  const template = bannerResult?.data?.template?.[0]?.images || [];
  // eslint-disable-next-line no-param-reassign
  item.data = template;
  return item;
};

const updateOffBoxComponent = async (item, deviceId, accessToken) => {
  const bannerResult = await fetResultAPI(item.api, deviceId, accessToken);
  if (item.id === 'middle-offbox-banner') {
    // eslint-disable-next-line no-param-reassign
    item.data = bannerResult?.data?.template?.[0]?.images || [];
  } else if (item.id === 'offbox-banner') {
    // eslint-disable-next-line no-param-reassign
    item.data = bannerResult?.data?.template?.[1]?.images || [];
  }
  return item;
};

const updateCategoryComponent = async (item, deviceId, accessToken) => {
  // eslint-disable-next-line no-param-reassign
  item.data = (await fetResultAPI(item.api, deviceId, accessToken)) || [];
  return item;
};

export const getHomePageJsonSSR = async (result) => {
  if (!result?.content) {
    return result;
  }

  const deviceId = uuidv4();
  const accessToken = await getAccessToken(deviceId);

  const updatedContent = await Promise.all(
    result.content.map((item) => {
      if (isBannerComponent(item)) {
        return updateBannerComponent(item, deviceId, accessToken);
      }
      if (isOffBoxComponent(item)) {
        return updateOffBoxComponent(item, deviceId, accessToken);
      }
      if (isCategoryComponent(item)) {
        return updateCategoryComponent(item, deviceId, accessToken);
      }

      return item;
    }),
  );

  return { ...result, content: updatedContent };
};

export const getUserDisplayData = (data, flag = false, isAdd = false) => {
  const name = `${data.resource?.name?.[0]?.given} ${flag ? '---' : data.resource?.name?.[0]?.family}`;
  const isPrimary = data.resource?.extension?.find((item) => item.url === 'isPrimary').valueBoolean;
  return {
    image: data.resource?.photo?.[0]?.url,
    nameInitial: data?.resource?.extension?.find((item) => item.url === 'nameInitials')?.valueString,
    title: name,
    isPrimary,
    subtitle: {
      text1: isPrimary && !isAdd ? 'Primary Account' : data.resource?.gender,
      text2: convertDateToServer(data.resource?.birthDate),
    },
    verification_status: data?.resource?.extension?.find((item) => item.url === 'status')?.valueString,
    id: data?.resource?.id,
  };
};

export const getUserDisplayDataFamily = (data) => ({
  nameInitial: data.nameInitials,
  title: data.name,
  subtitle: {
    text1: data.gender,
    text2: convertDateToCommaFormat(data.dateOfBirth),
  },
  id: data.hisSystemId,
});

export const getSlotSection = (title) => {
  let section = '';
  switch (title) {
    case 'morning': {
      section = 'Morning';
      break;
    }
    case 'afternoon': {
      section = 'Afternoon';
      break;
    }
    case 'evening': {
      section = 'Evening';
      break;
    }
    default:
      section = '';
  }
  return section;
};

export const days18YearsAgo = () => {
  const currentDate = moment();
  const pastDate = currentDate.clone().subtract(18, 'years');
  const daysDiff = currentDate.diff(pastDate, 'days');
  return daysDiff;
};

export const isAgeLessThan18 = (birthDate) => {
  const birthDateMoment = moment(birthDate);
  const currentDate = moment();
  const ageIndays = currentDate.diff(birthDateMoment, 'days');
  return ageIndays < days18YearsAgo();
};

export const extractQueryString = (url) => {
  const queryString = url.split('?')[1];
  return queryString;
}

export const fetchDataFromAPI = async (accessToken, deviceId, context, zoneData, filterParams = {}) => {
  let productsResponse = {};
  let params = {
    zone: zoneData,
    page: context?.query?.page ? context?.query?.page - 1 : 0,
    pageSize: PLP_PAGE_SIZE,
  };
  if (EXPRESS_DEFAULT_FLAG) {
    filterParams = { ...filterParams, express_bool: EXPRESS_DEFAULT_FLAG };
  }
  if (context?.query?.catPath) {
    filterParams = { ...filterParams, categoryPath: context?.query?.catPath };
  }
  if (context?.query?.brand && zoneData) {
    // call brand api
    const brandId = context?.query?.brand;
    params = getParams(context, params, filterParams);
    productsResponse = await fetch(`${PRODUCTS_BY_BRAND}/${brandId}${getQuery(params)}`, {
      headers: getApiAuthHeader({
        Authorization: `guest-token ${accessToken}`,
        deviceId,
      }),
    }).then((res) => res?.json());
  } else if (context?.query?.category && zoneData) {
    const catId = context?.query?.category;
    params = getParams(context, params, filterParams);
    productsResponse = await fetch(`${PRODUCTS_BY_CATEGORY}/${catId}${getQuery(params)}`, {
      headers: getApiAuthHeader({
        Authorization: `guest-token ${accessToken}`,
        deviceId,
      }),
    }).then((res) => res?.json());
  } else if (zoneData) {
    params = getParams(context, params, filterParams);
    productsResponse = await fetch(`${PRODUCTS_BY_SEARCH}${getQuery(params)}`, {
      headers: getApiAuthHeader({
        Authorization: `guest-token ${accessToken}`,
        deviceId,
      }),
    }).then((res) => res?.json());
  }
  return productsResponse;
};

export const formatNumber = (phoneNumberString) => {
  let cleaned, match, prefix, suffix, format;

  if (phoneNumberString?.startsWith('+971-')) {
    prefix = phoneNumberString?.split('-')[0];
    suffix = phoneNumberString?.split('-')?.slice(1)?.join('-');
    if (phoneNumberString?.startsWith('+971-') && phoneNumberString?.includes('-0') && suffix !== undefined) {
      const modifiedPhoneNumber = phoneNumberString?.replace('-0', '-');
      cleaned = ('' + modifiedPhoneNumber?.split('-')?.slice(1)?.join('-'))?.replace(/\D/g, '');
    } else {
      cleaned = ('' + suffix)?.replace(/\D/g, '');
    }
    match = cleaned?.match(/^(\d{1})(\d{4})(\d{3,})$/);
  } else if (phoneNumberString?.startsWith('+971 ')) {
    prefix = phoneNumberString?.split(' ')[0];
    suffix = phoneNumberString?.split(' ')[1];
    if (suffix?.startsWith('0')) {
      suffix = suffix?.slice(1);
    }
    format = suffix?.replaceAll('-', '');
    match = format?.match(/^(\d{1})(\d{4})(\d{3,})$/);
  }
  if (match) {
    return prefix + ' ' + match[1] + ' ' + match[2] + ' ' + match[3];
  }
  return phoneNumberString;
};

export const truncateName = (name, charLength = 30) => {
  const maxLength = charLength;
  if (name?.length > maxLength) {
    return name.substring(0, maxLength) + '...';
  }
  return name;
};

export const buildProductTitle = (options) => {
  const { content, showEllipsisInTitle, charPerRow } = options;
  try {
    if (typeof window === 'undefined') return content;

    if (!showEllipsisInTitle) return content;

    const dotsLength = 1;

    if (content?.length <= charPerRow * 2) {
      return content;
    }

    const firstTitlePart = `${content?.substr(0, charPerRow * 1 - dotsLength).trim()}`;
    const secondTitlePart = content?.slice(-charPerRow + dotsLength)?.trim();
    return (
      <div>
        <div> {`${firstTitlePart}..`}</div>
        <div>{`..${secondTitlePart}`}</div>
      </div>
    );
  } catch {
    return content;
  }
};

export const getCouponDiscount = (cartResponse) => cartResponse?.data?.totalSegmentInCart?.extension_attributes?.amrule_discount_breakdown?.find((itm) => itm?.coupon_type === '2')?.amount || 0;

export const expireOldCookies = (key, path = '/') => {
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
};

export const getResponsiveDataForSlider = (data) => {
  const isEven = data?.length % 2 === 0;
  const isNoOfElementsLessThanTen = data?.length < 10;
  const slidesWhenEven = Math.ceil(data?.length / 4);
  const slidesWhenOddAndMobiles = Math.ceil(data?.length / 3.5);
  const slidesMoreThanTenAndTablets = Math.floor(data?.length / 3.5);
  const slidesLessThanTenAndTabletsOrMore = Math.floor(data?.length / 1.5);
  return [
    {
      breakpoint: 2560,
      settings: {
        slidesToScroll: isEven ? slidesWhenEven : isNoOfElementsLessThanTen ? slidesLessThanTenAndTabletsOrMore : Math.floor(data?.length / 2.65),
      }
    },
    {
      breakpoint: 1860,
      settings: {
        slidesToScroll: isEven ? slidesWhenEven : isNoOfElementsLessThanTen ? slidesLessThanTenAndTabletsOrMore : Math.floor(data?.length / 1.4),
      }
    },
    {
      breakpoint: 1440,
      settings: {
        slidesToScroll: isEven ? slidesWhenEven : isNoOfElementsLessThanTen ? slidesLessThanTenAndTabletsOrMore : Math.floor(data?.length / 1.45),
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToScroll: isEven ? slidesWhenEven : isNoOfElementsLessThanTen ? slidesLessThanTenAndTabletsOrMore : Math.floor(data?.length / 2.5),
      }
    },
    {
      breakpoint: 980,
      settings: {
        slidesToScroll: isEven ? slidesWhenEven : isNoOfElementsLessThanTen ? slidesLessThanTenAndTabletsOrMore : slidesMoreThanTenAndTablets,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToScroll: isEven ? slidesWhenEven : isNoOfElementsLessThanTen ? slidesLessThanTenAndTabletsOrMore : slidesMoreThanTenAndTablets,
      },
    },
    {
      breakpoint: 850,
      settings: {
        slidesToScroll: isEven ? slidesWhenEven : isNoOfElementsLessThanTen ? Math.ceil(data?.length / 2) : slidesMoreThanTenAndTablets,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToScroll: isEven ? slidesWhenEven : isNoOfElementsLessThanTen ? slidesWhenOddAndMobiles : slidesMoreThanTenAndTablets,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToScroll: isEven ? slidesWhenEven : slidesWhenOddAndMobiles,
      },
    },
    {
      breakpoint: 480,
      settings: {
        variableWidth: true,
        slidesToScroll: isEven ? slidesWhenEven : slidesWhenOddAndMobiles,
        arrows: true,
      },
    },

    {
      breakpoint: 425,
      settings: {
        slidesToScroll: isEven ? slidesWhenEven : slidesWhenOddAndMobiles,
      },
    },
  ];
}
export const setIsInStoreApp = (instoreFlag) => {
  if (typeof window !== 'undefined' && instoreFlag?.enabled && window?.location?.host.indexOf(INSTORE_DOMAIN) > -1) {
    localStorage.setItem('instore', true);
  }
  else {
    localStorage.removeItem('instore');
  }
};

export const getIsInstoreApp = () => typeof window !== 'undefined' && localStorage.getItem('instore');

export const stringifyIfObject = (value) => {
  if (typeof value === 'object' && value !== null) {
    return JSON.stringify(value);
  }

  return value;
};

export const destructureAndGetCurrentCartItemsList = (cartData = {}) => {
  const currentCartItem = [];
  cartData.delivery_groups?.forEach(group => {
    const foundItem = group?.items?.filter(
      (cartItem) => !cartItem?.free_gift
        // cartItem?.sku === sku && TODO: check on this condition
    );
    if (!Array.isArray(foundItem)) {
      currentCartItem.push(foundItem);
    } else {
      foundItem.map(item => {
        currentCartItem.push(item);
      })
    }
  })
  const items = [];
  currentCartItem.forEach(ele => {
    items.push({
      item_id: ele?.sku,
      qty: ele?.qty,
      price: ele?.sale_price,
    })
  })
  return items;
}

export const camelize = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

export const sortArrayBasedOnOutOfStock = (resArray) => {
  if (resArray && resArray.length > 0) {
    const res = resArray?.sort((a, b) => a?.items?.out_of_stock - b?.items?.out_of_stock);
    return res[0];
  }
  return [];
};

export const getDeliveryDates = (deliveryGroups = {}) => {
  if(deliveryGroups.length === 0) return {
    rxTime: '',
    expressTime: '',
    flashTime: '',
    expectedDeliveryText: '',
  };
  return deliveryGroups?.reduce((acc, { delivery_type, expected_delivery_date }) => ({
    ...acc,
    ...(delivery_type === DELIVERY_TYPES.RX && { rxTime: expected_delivery_date }),
    ...(delivery_type === DELIVERY_TYPES.EXPRESS && { expressTime: expected_delivery_date }),
    ...(delivery_type === DELIVERY_TYPES.FLASH && { flashTime: expected_delivery_date }),
    ...(delivery_type === DELIVERY_TYPES.STANDARD && { expectedDeliveryText: expected_delivery_date })
  }), {});
}

export const downloadMultipleFiles = (files, timeOut = 500) => {
  // files array format files = [{name:"", uri: ""}];
  if(!Array.isArray(files) || !files.length)
    return;
  new Promise((resolve) => {
      const temporaryDownloadLink = document.createElement("a");
      temporaryDownloadLink.style.display = "none";
      document.body.appendChild(temporaryDownloadLink);
      resolve(temporaryDownloadLink);
    })
    .then((temporaryDownloadLink) => {
      const downloadPromises = [];
      for (const [index, file] of files.entries()) {
        const downloadPromise = new Promise((resolve) => {
          setTimeout(() => {
            temporaryDownloadLink.setAttribute("href", file?.uri || "");
            temporaryDownloadLink.setAttribute("download", file?.name || "");
            temporaryDownloadLink.click();
            resolve(temporaryDownloadLink);
          }, parseInt(timeOut) * index);
        });
        downloadPromises.push(downloadPromise);
      }
      return Promise.all(downloadPromises);
    })
    .then(([temporaryDownloadLink]) => {
      document.body.removeChild(temporaryDownloadLink);
    });
};

export const getTitle = (medication, nonMedication, windowSize, remainingCount = 0) => {
  const mergedList = titleCaseArray([...medication, ...nonMedication]);
  const mergedListLength = mergedList?.length;

  const stringLength = getStringLength(windowSize);

  const concatenatedString = mergedList?.join(', ');

  if (concatenatedString?.length <= stringLength) {
    return (
      <>
        {concatenatedString}
        {remainingCount > 0 && <span className="extra-count">+{remainingCount} More</span>}
      </>
    );
  }

  const shortenedString = concatenatedString?.substring(0, stringLength);
  const remainingItems = mergedListLength - shortenedString.split(', ').length;

  return (
    <>
      {shortenedString}...
      {remainingItems + remainingCount > 0 && (
        <span className="extra-count">+{remainingItems + remainingCount} More</span>
      )}
    </>
  );
};

const getStringLength = (windowSize) => {
  if (windowSize?.width > 790) {
    return 67;
  } else if (windowSize?.width > 760) {
    return 34;
  } else if (windowSize?.width > 420) {
    return 24;
  } else if (windowSize?.width > 365) {
    return 19;
  }
  return 0;
};

const titleCaseArray = (array) => {
  return array?.map((str) =>
    str
      ?.split(' ')
      ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
      ?.join(' '),
  );
};

export const ellipsisText = (text, size=5, position="center") => {
  let ellipText = '';
  if(!text?.length)
    return '';
  if(text?.length <= size)
    return text;
  if(position === "right")
    ellipText = `${text.substr(0,size)}...`
  else if(position === "center")
    ellipText = `${text.substr(0,size)}...${text.substr(text.length-size, text.length)}`
  else
    ellipText = text;
  return ellipText;
}

export const getPaymentOptionIconUrl = (method = '') => {
  if (method?.toUpperCase() === PAYMENT_METHODS.CASH || method?.toUpperCase() === PAYMENT_METHODS.COD) {
    return IC_COD_DARK_GREY.src;
  }
  if (method?.toUpperCase() === 'CARD' || method?.toUpperCase() === 'NEW_CARD' || method?.toUpperCase() === 'SAVED_CARD') {
    return IC_ORDERS_CREDIT_CARD.src;
  }
  if (method?.toUpperCase() === 'APPLEPAY') {
    return IC_PAY_APPLE.src;
  }
  return PRODUCT_CARD_DEFAULT.src;
};

export const checkIfCurrentRegionIsSaudi = () => {
  return getRegionCodeFromUrl().toUpperCase() === 'SA';
}

export const checkIfCurrentLangIsArabic = () => {
  return getLangCodeFromUrl().toLowerCase() === 'ar';
}

export const getRegionLangTimezoneFromUrl = (url = '') => {
  const segment = url?.split('/')?.[1];
  const lang = segment?.split('-')?.[1] ?? DEFAULT_HEADER_VALUES.langCode;
  const region = segment?.split('-')?.[0] ? segment?.split('-')?.[0].toUpperCase() : DEFAULT_HEADER_VALUES.regionCode;
  const timezone = COUNTRY_LIST.find(country => country?.langCode === lang && country?.regionCode?.toLowerCase() === region?.toLowerCase())?.timezone ?? DEFAULT_HEADER_VALUES.timezone

  return {region, lang, timezone};
}

export const groupByKey = (arr, key) => arr.reduce((acc, item) => ((acc[item[key]] = [...(acc[item[key]] || []), item]), acc), {});

export const getAppConfigDataByLang = (appConfigData, key, langCode) => {
  const appConfigDataByKey = appConfigData?.find((x) => x.name === key);
  return langCode === supportedlanguages.AR ? appConfigDataByKey?.valueAr : appConfigDataByKey?.value
}

export const sanitizeURL = (url) => {
  if (!url || typeof url !== 'string') return url;

  return url.replace(/([^:]\/)\/+/g, '$1');
};

export const checkAndUpdateOldCartId = (cartId = 0) => {
  if(typeof window !== 'undefined') {
    const oldCartId = sessionStorage.getItem(SESSION_STORAGE_KEYS?.OLD_CART_ID);
    if(!!cartId && !!oldCartId && Number(oldCartId) !== Number(cartId)) {
      sessionStorage.setItem(SESSION_STORAGE_KEYS?.OLD_CART_ID, cartId);
    }
  }
}

export function hasDecimals(num) {
  return num % 1 !== 0;
}

export const getHostCountry = () => window?.location?.href?.includes('/uae-') ? 'uae': 'sa';

export const clearAppStorage = (cb = undefined) => {
  sessionStorage.removeItem('topBarSession');
  removeCookieByName('userId');
  removeCookieByName('Guest_Token');
  localStorage.removeItem(LOCALSTORAGE_KEYS?.PRESCRIPTION_UPLOADED_FILES);
  localStorage.removeItem('Latitude');
  localStorage.removeItem('Longitude');
  localStorage.removeItem('persist_addressChange');
  localStorage.removeItem('PreselectedPatientId');
  localStorage.removeItem('preferredAddress');
  sessionStorage.removeItem('deliveryInstructions');
  localStorage.removeItem('uploadedHcDocs');
  localStorage.removeItem('hcCartId');
  localStorage.removeItem('map-user');
  sessionStorage.removeItem('bookAppointmentPatientDetails');
  localStorage.setItem('showLinkedProfiles', 'true');
  sessionStorage.removeItem('notificationList');
  localStorage.removeItem('userCountry');
  localStorage.removeItem('selectedProfile');
  sessionStorage.removeItem(SESSION_STORAGE_KEYS?.IS_MERGE_CART_CALLED);
  sessionStorage.removeItem(SESSION_STORAGE_KEYS?.OLD_CART_ID);
  if (cb) cb();
};
